import React from 'react';

interface ImprovementCardProps {
  index: number;
  name: string;
  date: string;
  position: string;
  department: string;
  supervisor: string;
  dateOfHire?: string;
  policyViolation: string;
  reasonForPerformanceImprovementPlan: string;
  expectationsAndGoals: string;
  timelineAndDeadline: string;
  resourcesAndSupport: string;
  privateNotes?: string;
  createdAt?: string;
}

const ImprovementCard = ({
  index,
  name,
  date,
  position,
  department,
  supervisor,
  dateOfHire,
  policyViolation,
  reasonForPerformanceImprovementPlan,
  expectationsAndGoals,
  timelineAndDeadline,
  resourcesAndSupport,
  privateNotes,
  createdAt,
}: ImprovementCardProps) => {
  return (
    <div className="mb-4 p-3 border rounded" style={{ backgroundColor: '#f8f9fa' }}>
      <h6 className="text-primary mb-3">
        <i className="fas fa-user mr-2" />
        {index + 1}. {name}
      </h6>

      <div className="row">
        <div className="col-md-6">
          <p>
            <strong>Date:</strong> {date}
          </p>
          <p>
            <strong>Position:</strong> {position}
          </p>
          <p>
            <strong>Department:</strong> {department}
          </p>
          <p>
            <strong>Supervisor:</strong> {supervisor}
          </p>
          {dateOfHire && (
            <p>
              <strong>Date of Hire:</strong> {dateOfHire}
            </p>
          )}
        </div>
        <div className="col-md-6">
          <p>
            <strong>Policy Violation:</strong> {policyViolation}
          </p>
          {createdAt && (
            <p>
              <strong>Created At:</strong> {createdAt}
            </p>
          )}
        </div>
      </div>

      <div className="mt-3">
        <p>
          <strong>Reason for Performance Improvement Plan:</strong>
        </p>
        <p className="text-muted" style={{ whiteSpace: 'pre-wrap' }}>
          {reasonForPerformanceImprovementPlan}
        </p>
      </div>

      <div className="mt-3">
        <p>
          <strong>Expectations and Goals:</strong>
        </p>
        <p className="text-muted" style={{ whiteSpace: 'pre-wrap' }}>
          {expectationsAndGoals}
        </p>
      </div>

      <div className="mt-3">
        <p>
          <strong>Timeline and Deadline:</strong>
        </p>
        <p className="text-muted" style={{ whiteSpace: 'pre-wrap' }}>
          {timelineAndDeadline}
        </p>
      </div>

      <div className="mt-3">
        <p>
          <strong>Resources and Support:</strong>
        </p>
        <p className="text-muted" style={{ whiteSpace: 'pre-wrap' }}>
          {resourcesAndSupport}
        </p>
      </div>

      {privateNotes && (
        <div className="mt-3">
          <p>
            <strong>Private Notes:</strong>
          </p>
          <p className="text-muted" style={{ whiteSpace: 'pre-wrap' }}>
            {privateNotes}
          </p>
        </div>
      )}
    </div>
  );
};

export default ImprovementCard;
